import React, { Component } from "react";
import _ from "lodash";
//for datepicker
import DatePicker from "react-datepicker";
import moment from "moment";
import styled from 'styled-components';

const getError = (name, { errors }) => {
  if (errors) {
    return errors[name] || "";
  }
  return "";
};

const getKlass = (fieldError, attrs = {}) => {
  const defaultKlass = attrs["klass"]
    ? `form-group ${attrs["klass"]} `
    : "form-group col-md-3";
  return _.isEmpty(fieldError) ? defaultKlass : `${defaultKlass} has-error`;
};

const filterAttrs = attrs => {
  const allowed = ["disabled", "className", "rows"];
  let out = {};
  for (var key in attrs) {
    if (allowed.includes(key)) {
      out[key] = attrs[key];
    }
  }
  return out;
};

const txtBox = (label, name, value, context, attrs = {}) => {
  // debugger
  const fieldError = getError(name, attrs);
  const klass = getKlass(fieldError, Object.assign({}, attrs));
  const acceptedAttrs = filterAttrs(attrs);
  return (
    <div className={klass}>
      <label>
        {label}
      </label>
      <br />
      <input
        className="form-control"
        name={name}
        value={value || ''}
        onChange={context.handleChange}
        {...acceptedAttrs}
      />
      {!_.isEmpty(fieldError) &&
        <div className="text-danger">
          {fieldError}
        </div>}
    </div>
  );
};

class SLBFile extends Component {
  constructor(props) {
    super(props);
    this.onImageChange = this.onImageChange.bind(this);
  }

  getBase64(file, handler) {
    var reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function() {
      let payload = reader.result;
      console.log(payload);
      handler(payload);
    };
    reader.onerror = function(error) {
      console.log("Error: ", error);
    };
  }

  onImageChange(e) {
    if (this.props.onImageChange) {
      //let reader = new FileReader();
      let file = e.target.files[0];
      console.log(file);
      console.log("jajj");
      this.getBase64(file, this.props.onImageChange);
    }
  }

  render() {
    let { label, name, attrs } = this.props;
    const fieldError = getError(name, attrs);
    const klass = getKlass(fieldError, Object.assign({}, attrs));

    return (
      <div className={klass}>
        <label>{label}</label>
        <input
          id="file"
          type="file"
          name={name}
          onChange={this.onImageChange}
        />
        {!_.isEmpty(fieldError) &&
          <div className="text-danger">
            {fieldError}
          </div>}

      </div>
    );
  }
}


const TextArea = styled.textarea`
  min-height: 200px !important;
`
const SLBTxtBox = ({ label, name, value, context, attrs = {} }) =>
  txtBox(label, name, value, context, attrs);

const SLBTextarea = ({ label, name, value, context, attrs = {} }) => {
  const fieldError = getError(name, attrs);
  const klass = getKlass(fieldError, Object.assign({}, attrs));
  const acceptedAttrs = filterAttrs(attrs);
  return (
    <div className={klass}>
      <label>
        {label}
      </label>
      <br />
      <TextArea
        className="form-control"
        name={name}
        value={value || ''}
        onChange={context.handleChange}
        {...acceptedAttrs}
      />
      {!_.isEmpty(fieldError) &&
        <div className="text-danger">
          {fieldError}
        </div>}
    </div>
  );
};

import RichEditor from "./RichEditor";
// import MyStatefulEditor from "./MyStatefulEditor";

const SLBEditor = ({ label, value, handleEditorChanged, attrs = {} }) => {
  return (
    <div className="">
      <label>
        {label}
      </label>
      <RichEditor onChange={handleEditorChanged} />
    </div>
  );
};

const comboBox = (
  label,
  name,
  value,
  context,
  options = [],
  values = [],
  attrs = {}
) => {
  const fieldError = getError(name, attrs);
  const klass = getKlass(fieldError, attrs);
  let _options = options.map((name, idx) => {
    let val = values[idx] || name;
    return (
      <option value={val} key={idx}>
        {name}
      </option>
    );
  });

  return (
    <div className={klass}>
    <label>
        {label}
      </label>
      <br />
      <select
        className="form-control"
        name={name}
        value={value}
        onChange={context.handleChange}
      >
        {_options}
      </select>
      {!_.isEmpty(fieldError) &&
        <div className="text-danger">
          {fieldError}
        </div>}
    </div>
  );
};

const SLBSelect = ({
  label,
  name,
  value,
  context,
  options = [],
  values = [],
  attrs = {}
}) => comboBox(label, name, value, context, options, values, attrs);

const datePicker = (label, name, value, handleChange, attrs) => {
  const fieldError = getError(name, attrs);
  const klass = getKlass(fieldError, attrs);
  // const acceptedAttrs = filterAttrs(attrs);
  return (
    <div className={klass}>
      <label>
        {label}
      </label>
      <br />
      <DatePicker
        selected={value ? moment(value) : null}
        onChange={handleChange}
        className="form-control col-md-12"
        name={name}
        peekNextMonth
        showMonthDropdown
        showYearDropdown
        dropdownMode="select"
        filterDate = {attrs["filterDate"]}
      />
      {!_.isEmpty(fieldError) &&
        <div className="text-danger">
          {fieldError}
        </div>}
    </div>
  );
};

const SLBDatePicker = ({ label, name, value, handleChange, attrs }) =>
  datePicker(label, name, value, handleChange, attrs);

import "rc-time-picker/assets/index.css";
//requires moment
import TimePicker from "rc-time-picker";

const SLBTimePicker = ({ label, name, value, handleChange, attrs }) => {
  const format = "h:mm a";
  const now = value || moment().hour(0).minute(0);
  const fieldError = getError(name, attrs);
  const klass = getKlass(fieldError, attrs);
  delete attrs.errors;
  return (
    <div className={klass}>
      <label>
        {label}
      </label>
      <br />
      <TimePicker
        showSecond={false}
        defaultValue={now}
        className=""
        onChange={handleChange}
        format={format}
        use12Hours
      />
      {!_.isEmpty(fieldError) &&
        <div className="text-danger">
          {fieldError}
        </div>}
    </div>
  );
};

const SLBDateTimePicker = ({label, name, value, handleChange, attrs}) => {

  const fieldError = getError(name, attrs);
  const klass = getKlass(fieldError, attrs);
  // const acceptedAttrs = filterAttrs(attrs);
  return (
    <div className={klass}>
      <label>
        {label}
      </label>
      <br />
      <DatePicker
        selected={value ? moment(value) : null}
        onChange={handleChange}
        className="form-control col-md-12"
        name={name}
        peekNextMonth
        showMonthDropdown
        showYearDropdown
        dropdownMode="select"
        showTimeSelect
        timeFormat="HH:mm"
        timeIntervals={15}
        dateFormat="DD MMM, YYYY - HH:mm"
      />
      {!_.isEmpty(fieldError) &&
        <div className="text-danger">
          {fieldError}
        </div>}
    </div>
  );
}

export {
  txtBox,
  comboBox,
  datePicker,
  SLBTimePicker,
  SLBTxtBox,
  SLBTextarea,
  SLBEditor,
  SLBDatePicker,
  SLBSelect,
  SLBFile,
  SLBDateTimePicker
};



// WEBPACK FOOTER //
// ./src/utils/Forms.js